import { selectPartners, selectPartnersLoading } from "@/entities/partner";
import { useAppSelector } from "@/shared/lib/redux";
import { FC, useMemo } from "react";
import ReactSelect from "react-select";
import ArrowDown from '@/shared/assets/images/ArrowDown.svg'

interface SelectPartnerProps {
    value: string | null
    onChange: (value: string) => void
    className?: string
    isMulti?: boolean
}

export const SelectPartner: FC<SelectPartnerProps> = ({ value, onChange, className }) => {
    const partners = useAppSelector(selectPartners)
    const partnersLoading = useAppSelector(selectPartnersLoading)

    const selectOptions = useMemo(() => [{
        label: 'Все юрлица',
        value: null
    }, ...partners.map(partner => ({
        value: partner.id,
        label: partner.name
    }))], [partners])
    
    return (
        <ReactSelect
            className={`w-full text-color-dark flex items-center px-4 h-[52px] bg-white rounded-full ${className}`} 
            options={selectOptions}
            classNames={{
                control: () => '!border-0 !p-0 !outline-0 !min-h-[auto] w-full !border-transparent !shadow-none',
                valueContainer: () => '!border-0 !outline-0 !p-0',
                menu: () => '!left-[0]',
            }}
            noOptionsMessage={() => 'Нет опций'}
            classNamePrefix="react_select_custom"
            isLoading={partnersLoading}
            components={{
                DropdownIndicator: () => <ArrowDown height={20} width={20}/>,
                IndicatorSeparator: () => null
            }}
            onChange={(el) => onChange(el.value)}
            value={selectOptions.find(option => option.value === value)}
        />
    )
}